import React from 'react';
import { Button, Container, Image } from '@uncinc/uncinc-react-kitchen-sink';
import WysiwygField from '../WysiwygField';

import { SCREEN_MOBILE, SCREEN_NORMAL, SCREEN_WIDE } from '../../config/constants';

import './style.scss';

const CTA = ({
  title,
  body,
  link,
  linkTitle,
  linkTarget = '_self',
  secondaryLink,
  secondaryLinkTitle,
  secondaryLinkTarget = '_self',
  small,
  imageStyles,
}) => {
  return (
    <Container className={`CTAComponent ${imageStyles && 'withImage'}`}>
      <div className="row">
        <div className={`CTAWrapper col-12 ${imageStyles ? 'col-md-8 col-lg-7' : 'col-lg-10 offset-lg-1'}`}>
          <div className={`CTA ${small ? 'CTA__small' : ''}`}>
            {title && <h3 className="CTA__title">{title}</h3>}
            {body && <WysiwygField
              property="schema:text"
              className="CTA__body"
              html={body}
            />}
            {(link || secondaryLink) &&
              <div className="CTA__buttonWrapper">
                {link && linkTitle && <Button href={link} target={linkTarget}>{linkTitle}</Button>}
                {secondaryLink && secondaryLinkTitle && (
                  <a className="CTA__buttonWrapper__link" href={secondaryLink} target={secondaryLinkTarget}>
                    {secondaryLinkTitle}
                    <i className="icon icon-arrow-right icon-variant-1" />
                  </a>
                )}
              </div>}
          </div>
        </div>
        {imageStyles && (
          <div className="CTAImage col-12 col-md-5 offset-md-7 col-lg-6 offset-lg-6">
            <Image
              src={{
                [SCREEN_MOBILE]: imageStyles.getIn(['4_3_mobile']),
                [SCREEN_NORMAL]: imageStyles.getIn(['image_grid_square_tablet']),
                [SCREEN_WIDE]: imageStyles.getIn(['4_3_mobile']),
              }}
            />
          </div>
        )}
      </div>
    </Container>

  );
};

export default CTA;
